import {
  Box,
  Button,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { noticeToCreditorsFlow } from "../index";
import * as Yup from "yup";
import { Formik, FormikHelpers } from "formik";
import { OUTCOMES } from "../../../constants";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

interface Values {
  businessEmail: string;
}

interface Props {
  businessEmail?: string;
}

export const BizEmailScreen = ({ businessEmail }: Props): JSX.Element => {
  const navigate = useNavigate();
  const { screenName } = useParams();
  const currentScreen = noticeToCreditorsFlow.getCurrentFlowScreen(screenName);

  // https://formik.org/docs/api/formik
  const formikInit = {
    values: {
      businessEmail: "",
    },
    schema: Yup.object().shape({
      businessEmail: Yup.string().email(),
    }),
  };

  const handleSubmit = async (
    values: Values,
    { setSubmitting, setStatus }: FormikHelpers<Values>
  ) => {
    setStatus("");
    try {
      if (!currentScreen) throw Error("couldn't determine currentScreen");

      // TODO: save to database

      const nextPath = noticeToCreditorsFlow.getNextScreen(
        currentScreen,
        OUTCOMES.complete
      );
      navigate(nextPath);
    } catch (error) {
      setStatus("Sorry, error: " + ((error as Error)?.message || ""));
      // logger.error(error);
      setSubmitting(false);
    }
  };

  return currentScreen ? (
    <>
      <Box
        sx={{
          width: "100%",
          maxWidth: 800,
          py: 2,
        }}
      >
        <Typography component="h2" variant="h5">
          {businessEmail || "What is your business email address?"}
        </Typography>
        <Formik
          initialValues={formikInit.values}
          validationSchema={formikInit.schema}
          onSubmit={handleSubmit}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values,
            status,
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid
                container
                spacing={1}
                sx={{
                  my: 1,
                }}
              >
                <Grid item xs={12}>
                  <TextField
                    error={Boolean(
                      touched.businessEmail && errors.businessEmail
                    )}
                    fullWidth
                    helperText={touched.businessEmail && errors.businessEmail}
                    label="Business email address"
                    margin="normal"
                    name="businessEmail"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="text"
                    value={values.businessEmail}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{
                    my: 2,
                  }}
                >
                  <Typography
                    variant="body1"
                    color="error"
                    style={{ marginRight: 8 }}
                  >
                    {status}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <IconButton
                      aria-label="back"
                      onClick={() => navigate(-1)}
                      sx={{ mr: 2 }}
                      className="inverse"
                    >
                      <ArrowBackIcon />
                    </IconButton>
                    <Button
                      variant="contained"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      Continue
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      </Box>
    </>
  ) : (
    <></>
  );
};
